const species = [
    "All",
    "London plantree",
    "honeylocust",
    "Callery pear",
    "pin oak",
    "Norway maple",
    "littleleaf linden",
    "cherry",
    "Japanese zelkova",
    "ginkgo",
    "Sophora"
  ]
  
  export default species
  